const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const Totem = () => import(/* webpackChunkName: "totem" */ './view/edit.vue');

export const ROUTE_NAME_TOTEM = 'Totem' as const;

export default [
    {
        path: '/app/:appId/totem',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_TOTEM,
                component: Totem,
                meta: { requiresAuth: true }
            }
        ]
    }
];
